import { request } from './request.js'

export const getProductsSidebar = () => request.get('products/sidebar')
